var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 47,
    viewBox: "0 0 39 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7032 19.4072C35.7032 32.1684 19.3516 43.1066 19.3516 43.1066C19.3516 43.1066 3 32.1684 3 19.4072C3 10.3468 10.3219 3 19.3516 3C28.3813 3 35.7032 10.3468 35.7032 19.4072Z",
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3516 24.8764C22.3619 24.8764 24.8021 22.4278 24.8021 19.4073C24.8021 16.3868 22.3619 13.9382 19.3516 13.9382C16.3414 13.9382 13.9011 16.3868 13.9011 19.4073C13.9011 22.4278 16.3414 24.8764 19.3516 24.8764Z",
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPin);
export default __webpack_public_path__ + "static/media/icon-pin.7da0ec627daaf67026c6927ea72f89f2.svg";
export { ForwardRef as ReactComponent };